import service from "@/store/services/elixio-shipments-estimations-service";
import Jsona from "jsona";

const jsona = new Jsona();

export const state = () => ({
  list: {},
  elixioShipmentsEstimation: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, elixioShipmentsEstimation) => {
    state.elixioShipmentsEstimation = elixioShipmentsEstimation;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((elixioShipmentsEstimation) => {
      commit("SET_RESOURCE", elixioShipmentsEstimation);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((elixioShipmentsEstimation) => {
      commit("SET_RESOURCE", elixioShipmentsEstimation);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((elixioShipmentsEstimation) => {
      commit("SET_RESOURCE", elixioShipmentsEstimation);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  elixioShipmentsEstimation: (state) => state.elixioShipmentsEstimation,
  url: (state) => state.url,
  dropdown: (state) => {
    return state.list.map((elixioShipmentsEstimation) => ({
      id: elixioShipmentsEstimation.id,
      status: elixioShipmentsEstimation.status,
    }));
  },
};

const elixioShipmentsEstimations = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default elixioShipmentsEstimations;
